import { createApp } from 'vue'
import App from './App.vue'
import "@/assets/css/init.css"
import '@icon-park/vue-next/styles/index.css';
import router from '@/router'
import DataVVue3 from '@kjgl77/datav-vue3'
import { createPinia } from 'pinia'
const pinia = createPinia();
const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(DataVVue3)
app.mount('#app')

